// removed by extract-text-webpack-plugin
module.exports = {"Footer":"footer__Footer__3eoMD","FooterLeft":"footer__FooterLeft__1ZJaD","FooterRight":"footer__FooterRight__2bOte"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Footer/footer.css
// module id = 124
// module chunks = 0